import React, { useState, useRef } from 'react';

import { valMsg } from '../../../../../actions/swal_msg';

//MUI
import {
    Button, TextField, Typography, Grid, Alert, Card, CardContent,
} from '@mui/material';

//Date fns
import { isValid, format } from 'date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const regex = /^[0-9\b]+$/;

const initialBatch = {
    batch: '',
    total_pieces: '',
    expiration_date: new Date()
};

const inputErrors = {
    batch_err: false,
    pieces_err: false
};

const ProductVariantBatch = ({ variant_key, batches, setProdValues }) => {
    // referencias a campos
    const batchRef = useRef();
    const piecesRef = useRef();
    // valores de lote
    const [batchValues, setBatch] = useState(initialBatch);
    const { batch, total_pieces, expiration_date } = batchValues;
    // errores en campos
    const [inputErr, setInputErr] = useState(inputErrors);
    const { batch_err, pieces_err } = inputErr;

    // validación formulario de lote
    const formValidator = () => {
        const batch_len = batch.trim().length;
        const pieces_len = total_pieces.trim().length;
        if (batch_len > 1 && batch_len <= 80) {
            if (pieces_len > 0 && pieces_len <= 5
                && regex.test(total_pieces))
                if (isValid(expiration_date)) {
                    const found = batches.find(e => e.batch === batch)
                    if (!found)
                        return true;
                    else
                        valMsg('warning', 'Lote de variante',
                            'Identificador de lote ya existe');
                } else
                    valMsg('warning', 'Lote de variante',
                        'Ingrese una fecha de caducidad');
            else {
                piecesRef.current.select();
                valMsg('warning', 'Lote de variante',
                    'Ingrese cantidad de piezas');
            }
        } else {
            batchRef.current.select();
            valMsg('warning', 'Lote de variante',
                'Ingrese identificador de lote');
        }
        // establece errores en los campos
        setInputErr({
            ...inputErr,
            batch_err: (batch.length < 2 ||
                batch.length > 80) ? true : false,
            pieces_err: (total_pieces.length < 1 ||
                total_pieces.length > 5 ||
                !regex.test(total_pieces)) ? true : false
        });
        return false;
    };

    // agregar lote de producto
    const addBatch = () => {
        if (formValidator()) {
            setProdValues(e => ({
                ...e,
                variants: e.variants.map(variant =>
                    (variant.key === variant_key) ?
                        {
                            ...variant,
                            batches: [...variant.batches, batchValues]
                        } : variant
                )
            }));
            setBatch(initialBatch);
        }
    };

    // cambios en campos de lote
    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'total_pieces') {
            if (value === '' || regex.test(value))
                setBatch(e => ({ ...e, total_pieces: value }));
        } else setBatch(e => ({ ...e, [name]: value }));
        switch (name) {
            case 'batch':
                setInputErr({
                    ...inputErr,
                    batch_err: (value.length < 2 ||
                        value.length > 80) ? true : false
                });
                break;
            case 'pieces':
                setInputErr({
                    ...inputErr,
                    pieces_err: (value.length < 1 ||
                        value.length > 5) ? true : false
                });
                break;
            default:
                break;
        }
    };

    return (
        <>
            <Typography variant="h6" sx={{ fontWeight: '600' }} gutterBottom>
                Inventario
            </Typography>
            {
                batches.length > 0
                    ?
                    <Grid container spacing={2}>
                        {
                            batches.map((e, i) =>
                                <Grid item xxl={4} xl={4} lg={6} md={6} sm={12} xs={12}>
                                    <Card variant='outlined' sx={{ width: '100%' }}>
                                        <CardContent sx={{ '&:last-child': { pb: 1 } }}>
                                            <Typography variant='h6' sx={{ fontWeight: '600' }}>{`Lote: ${e.batch}`}</Typography>
                                            <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>
                                                {`Piezas de lote: ${e.total_pieces}`}
                                            </Typography>
                                            <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>
                                                {`Fecha de caducidad: ${format(e.expiration_date, 'dd/MM/yyyy')}`}
                                            </Typography>
                                            <Button color='error'
                                                onClick={() => {
                                                    setProdValues(prod => ({
                                                        ...prod,
                                                        variants: prod.variants.map(variant =>
                                                            (variant.key === variant_key) ?
                                                                {
                                                                    ...variant,
                                                                    batches: variant.batches.filter(u => u.batch !== e.batch)
                                                                } : variant
                                                        )
                                                    }));
                                                }}
                                            >
                                                Eliminar
                                            </Button>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        }
                    </Grid>
                    :
                    <Alert severity='info'>Esta variante no cuenta con ningún lote</Alert>
            }

            <Grid container spacing={3.5} sx={{ mt: 0 }}>
                <Grid item xs={12}>
                    <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Lote:</Typography>
                    <TextField
                        fullWidth
                        name="batch"
                        placeholder="Lote"
                        variant="outlined"
                        value={batch}
                        inputProps={{ maxLength: 80 }}
                        error={batch_err}
                        helperText={batch_err ? "Ingrese identificador de lote" : ""}
                        inputRef={batchRef}
                        onChange={handleInputChange}
                        sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                    />
                </Grid>

                <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Piezas totales en lote:</Typography>
                    <TextField
                        fullWidth
                        name="total_pieces"
                        placeholder="Piezas en lote"
                        variant="outlined"
                        value={total_pieces}
                        inputProps={{ maxLength: 5 }}
                        error={pieces_err}
                        helperText={pieces_err ? "Ingrese cantidad de piezas" : ""}
                        inputRef={piecesRef}
                        onChange={handleInputChange}
                        sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                    />
                </Grid>

                <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Fecha de caducidad:</Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            placeholder="Fecha de caducidad"
                            value={expiration_date}
                            onChange={(newValue) => {
                                setBatch({ ...batchValues, expiration_date: newValue });
                            }}
                            renderInput={
                                (params) =>
                                    <TextField fullWidth {...params} sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }} />
                            }
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12}>
                    <Button variant="outlined" sx={{ textTransform: 'none' }} onClick={addBatch}>
                        Guardar lote
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default ProductVariantBatch;